import { defineStore } from 'pinia';

// const STORAGE_KEY_PREFIX = 'teachino.feature-flag.';

// const readStoredBoolean = (key: string, fallback: boolean): boolean => {
//   if (typeof window === 'undefined') {
//     return fallback;
//   }
//
//   try {
//     const value = window.localStorage.getItem(`${STORAGE_KEY_PREFIX}${key}`);
//     if (value === 'true') {
//       return true;
//     }
//     if (value === 'false') {
//       return false;
//     }
//   } catch {
//     return fallback;
//   }
//
//   return fallback;
// };

// const writeStoredBoolean = (key: string, value: boolean) => {
//   if (typeof window === 'undefined') {
//     return;
//   }
//
//   try {
//     window.localStorage.setItem(`${STORAGE_KEY_PREFIX}${key}`, String(value));
//   } catch {
//     // Ignore storage write failures (e.g. private mode/quota/security restrictions).
//   }
// };

// const createPersistedBooleanFlag = (key: string, defaultValue: boolean) => {
//   const flag = ref(readStoredBoolean(key, defaultValue));
//
//   watch(flag, (value) => {
//     writeStoredBoolean(key, value);
//   });
//
//   return flag;
// };

export const useFeatureFlags = defineStore('feature-flags', () => {
  return {};
});
